import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    return {
      title: props.launcher.name,
      resource_id: props.resourceId,
      steps: props.launcher.properties.map(property => ({
        id: `${props.launcher.id}-${property.key}`,
        launcher_id: props.launcher.id,
        name: property.name,
        key: property.key,
        value: null,
        type: property.type,
        values: property.values,
        source: property.source,
        required: property.required,
        description: property.description,
      })),
      current_index: 0,
    }
  }, [props.launcher, props.resourceId])
}
